/* QUI RECOIT UNE RELANCE.

   La regle est celle du serveur - `DelaiServiceImpl.envoyerAlerteMail` - et elle depend
   du NIVEAU de l'alerte :

     toujours          le redacteur responsable du dossier, ou a defaut son createur ;
     URGENT, CRITIQUE  en plus, tous les utilisateurs du profil CSS ;
     CRITIQUE          en plus, tous les utilisateurs du profil SE.

   CE MODULE NE CALCULE PAS D'ADRESSES, et c'est deliberе. Reproduire ici la resolution
   des courriels - lire l'email du responsable, charger les listes CSS et SE - ferait
   vivre la meme regle a deux endroits : le jour ou le serveur ajoute un profil, l'ecran
   annoncerait une liste fausse, et c'est pire que de ne rien annoncer. On nomme donc le
   responsable, connu de la ligne, et les PROFILS pour le reste.

   Les profils sont nommes par leur code. Leur libelle est vide en base : inventer
   « chef de service » serait une supposition affichee a l'utilisateur. */

import i18n from '../../i18n';

/** Les niveaux qui ajoutent les superviseurs CSS. */
const NIVEAUX_AVEC_CSS = ['URGENT', 'CRITIQUE'];

/**
 * Les destinataires d'une relance, en clair.
 *
 * @param {object} delai la ligne d'alerte (`niveauAlerte`, `responsableNomPrenom`)
 * @returns {string[]} une ligne par destinataire, dans l'ordre ou le serveur les ajoute
 */
export function destinatairesRelance(delai) {
  const niveau = delai?.niveauAlerte;
  const lignes = [
    delai?.responsableNomPrenom
      ? i18n.t('delais:relances.destinataires.responsable', { nom: delai.responsableNomPrenom })
      // Le serveur retombe sur `createdBy` quand le dossier n'a pas de responsable.
      : i18n.t('delais:relances.destinataires.createur'),
  ];
  if (NIVEAUX_AVEC_CSS.includes(niveau)) {
    lignes.push(i18n.t('delais:relances.destinataires.profilCss'));
  }
  if (niveau === 'CRITIQUE') {
    lignes.push(i18n.t('delais:relances.destinataires.profilSe'));
  }
  return lignes;
}

/**
 * Les destinataires pour un dossier entier : l'union de ceux de ses delais.
 *
 * <p>Relancer un dossier envoie un courriel PAR DELAI, et les niveaux peuvent differer.
 * Annoncer les destinataires du premier delai seulement serait faux des que le dossier
 * en porte un critique et un modere.
 */
export function destinatairesDossier(delais) {
  const vus = new Set();
  const lignes = [];
  (delais || []).forEach((d) => {
    destinatairesRelance(d).forEach((l) => {
      if (!vus.has(l)) { vus.add(l); lignes.push(l); }
    });
  });
  return lignes;
}

/** « 3 relances » / « 1 relance », pour le texte de la confirmation. */
export function compteRelances(n) {
  return i18n.t('delais:relances.compte', { count: n });
}
